// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist-template-view-page {
  position: relative;
}
.fi-checklist-template-view-page .fi-edit-page-content:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist-template/checklist-template-view/checklist-template-view.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAEQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AAAZ","sourcesContent":[".fi-checklist-template-view-page {\r\n    position: relative;\r\n\r\n    .fi-edit-page-content {\r\n        &:before {\r\n            content: '';\r\n            display: block;\r\n            position: absolute;\r\n            top: 0;\r\n            right: 0;\r\n            bottom: 0;\r\n            left: 0;\r\n            z-index: 1;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
